module.exports = __webpack_public_path__ + "static/iel-1542c310621ec94af0fce2610c2f9fb2.png";